import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MediaShareDetail, MediaShareMenuBrand } from '../../../models/new/media-share-detail';

@Component({
  standalone: false,
  selector: 'bt-company-media-share-link-detail-menu',
  templateUrl: './company-media-share-link-detail-menu.component.html',
  styleUrls: ['./company-media-share-link-detail-menu.component.scss']
})
export class CompanyMediaShareLinkDetailMenuComponent {
  @Input() menu: MediaShareMenuBrand[] = [];
  @Input() activeModelId: number | null = null;
  @Output() selectProduct = new EventEmitter<MediaShareDetail>();

  collapsedKeys = new Set<string>();

  toggleNode(key: string): void {
    if (this.collapsedKeys.has(key)) {
      this.collapsedKeys.delete(key);
    } else {
      this.collapsedKeys.add(key);
    }
  }

  isOpen(key: string): boolean {
    return !this.collapsedKeys.has(key);
  }

  getShotsCount(product: MediaShareDetail): number {
    return product.colors.reduce((count, color) => count + color.shots.filter((shot) => !!shot.imgPath).length, 0);
  }
}
